import React ,{ PropTypes } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import {API} from '../settings.js';
import {ajaxPost} from '../helpers/apiData.js';

import FeedbackRadios from './FeedbackRadios';

class Feedback extends React.Component {
  static propTypes = {
    lang: PropTypes.string,
    match: PropTypes.object,
    restaurant: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      back: "",
      howRecommend: 0,
      howLike: 0,
      message: "",
      likeError: '',
      recommendError: '',
      sent: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    if(this.state.howLike === 0) {
      this.setState({likeError: 'active'});
    }
    else if (this.state.howRecommend === 0) {
      this.setState({recommendError: 'active'});
    }
    else {
      ajaxPost(API +  this.props.match.params.lang + '/api/' + this.props.match.params.restaurant +'/feedback/',
        {'recommend': this.state.howRecommend, 'like': this.state.howLike, 'message': this.state.message},
        this);
      this.setState({sent: 'sent'});
    }
    event.preventDefault();
  }

  render() {
    return (
      <div className="pickly-feedback-wrapper feedback-wrapper">
        <div className={"feedback-form-wrapper " + this.state.sent}>
          <FormattedMessage id="feedback-title">
            {(message) => <h3 className="feedback-title">{message}</h3>}
          </FormattedMessage>
          <h5 className="feedback-subtitle">Pickly App</h5>
          <FormattedMessage id="feedback-intro">
            {(message) => <p className="intro-text">{message}</p>}
          </FormattedMessage>
          <form className="pickly-feedback feedback-form" onSubmit={this.handleSubmit}>
            <div>
              <FormattedMessage id="feedback-improve">
                {(message) => <h5>{message}*</h5>}
              </FormattedMessage>
              <FormattedMessage id="feedback-error">
                {(message) => <span className={'error-msg' + ' ' + this.state.likeError}>{message}</span>}
              </FormattedMessage>
              <FeedbackRadios name={'improve'}/>
            </div>
            <div>
              <FormattedMessage id="feedback-recommend">
                {(message) => <h5>{message}*</h5>}
              </FormattedMessage>
              <FormattedMessage id="feedback-error">
                {(message) => <span className={'error-msg' + ' ' + this.state.recommendError}>{message}</span>}
              </FormattedMessage>
              <FeedbackRadios name={'recommend'}/>
            </div>
            <div>
              <FormattedMessage id="feedback-msg">
                {(message) => <label className="feedback-msg-label" htmlFor="message">{message}</label>}
              </FormattedMessage>
              <textarea name="message" id="message" value={this.state.message} onChange={this.handleChange}/>
              <FormattedMessage id="feedback-submit">
                {(message) => <input className="btn" type="submit" value={message} />}
              </FormattedMessage>
            </div>
          </form>
        </div>

        <div className={'thanks ' + this.state.sent}>
          <img src={require('../images/placeholder_prato.jpg')} />
          <FormattedMessage id="feedback-thanks-title">
            {(message) => <h3>{message}</h3>}
          </FormattedMessage>
          <FormattedMessage id="feedback-thanks-text">
            {(message) => <p>{message}</p>}
          </FormattedMessage>
          <Link className="thanks-btn btn"
                to={'/' + this.props.lang + '/' + this.props.restaurant + '/'}>
            <FormattedMessage id="nav_home">
              {(message) => <span>{message}</span>}
            </FormattedMessage>
          </Link>
        </div>
      </div>
    );
  }
}

export default Feedback;




/** WEBPACK FOOTER **
 ** ./src/components/Feedback.js
 **/